import { render, staticRenderFns } from "./DialogEditarTipoPagamento.vue?vue&type=template&id=32a21b96&"
import script from "./DialogEditarTipoPagamento.vue?vue&type=script&lang=js&"
export * from "./DialogEditarTipoPagamento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports